import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

const isElectron = typeof window !== 'undefined' && window.electronAPI?.isElectron === true;

/**
 * Composant pour protéger les routes privées.
 * En mode Electron, bypass l'auth si le setup a été effectué.
 */
function PrivateRoute({ children }) {
  const location = useLocation();

  const isAuthenticated = () => {
    if (isElectron) return !!localStorage.getItem('era_desktop_user');
    return !!localStorage.getItem('era_token');
  };

  if (!isAuthenticated()) {
    const redirectTo = isElectron ? '/setup' : '/login';
    return <Navigate to={redirectTo} state={{ from: location }} replace />;
  }
  return children;
}

export default PrivateRoute;
